import React from 'react'
import HeroSection from '../Comman/HeroSection'



export default function PebModels() {
  return (
    <div className=' w-full h-screen flex justify-center items-center'>

<iframe id="view360Iframe" className='fixed top-0 left-0 bg-opacity-0' width="100%" height={"100%"} scrolling="0" src="https://sketchfab.com/models/7100482105254744b86ffe18f5a588bc/embed?ui_infos=0&amp;ui_watermark=0&amp;ui_help=0&amp;ui_settings=0&amp;ui_inspector=0&amp;ui_annotations=0&amp;ui_stop=0&amp;ui_vr=0&amp;preload=1&amp;autostart=1&amp;ui_hint=2&amp">
</iframe>

<div className=' bg-white w-full h-20 fixed bottom-0 lg:flex-row flex flex-col gap-y-3  justify-between items-center py-4 px-8 rounded-tl-2xl rounded-tr-2xl  left-0 z-[9999] '>

  <div className=' flex text-black lg:w-1/2 w-full font-bold lg:text-xl gap-x-5 text-xs'>

  Explore cutting-edge factory through our dynamic 3D model, revealing innovative steel manufacturing processes.
  </div>
  <h1 className='text-text-orange font-medium  text-md lg:text-xl'>
 
 3D Model 360 degree View

  </h1>
</div>
    </div>
  )
}
